import type { ComponentPropsWithoutRef, ElementType } from 'react';

const LEVEL_CLASS = {
  1: 'text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight',
  2: 'text-3xl sm:text-4xl font-bold tracking-tight',
  3: 'text-2xl sm:text-3xl font-semibold tracking-tight',
  4: 'text-xl sm:text-2xl font-semibold',
  5: 'text-lg font-semibold',
  6: 'text-base font-semibold',
} as const;

type HeadingLevel = keyof typeof LEVEL_CLASS;

interface HeadingProps extends ComponentPropsWithoutRef<'h1'> {
  level: HeadingLevel;
  as?: ElementType;
}

export function Heading({ level, as, className, ...props }: HeadingProps) {
  const Tag: ElementType = as ?? (`h${level}` as ElementType);
  return (
    <Tag
      className={['text-foreground', LEVEL_CLASS[level], className].filter(Boolean).join(' ')}
      {...props}
    />
  );
}
